import Remind from './Remind';
export default Remind;
